import { IDeadlineSchema, INewBuildingHouseSchema } from 'shared/types/api-models/offer-card/v1/get-offer-data';

import { getFormattedDeadlinePeriod } from './getFormattedDeadlinePeriod';

export const getFormattedDeadline = (
  deadline?: IDeadlineSchema | null,
  house?: INewBuildingHouseSchema | null,
): string => {
  if (deadline) {
    const formattedDeadline = getFormattedDeadlinePeriod(deadline);
    const deadlineText = formattedDeadline ? ` в ${formattedDeadline}` : '';

    if (deadline.isComplete) {
      return 'сдан' + deadlineText;
    }

    if (deadlineText) {
      return 'сдача' + deadlineText;
    }
  }

  if (house) {
    const formattedDeadline = house.finishDate ? ` в ${house.finishDate.quarter} кв. ${house.finishDate.year}` : '';

    if (house.isFinished) {
      return 'сдан' + formattedDeadline;
    }

    if (formattedDeadline) {
      return 'сдача' + formattedDeadline;
    }
  }

  return '';
};
